import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TextFacetLocal } from 'components/Filter/Filter.types';
import { getUniversalProductsFilter, setUniversalProductsInitialTextFilters } from 'domains/catalog/Catalog.store';

export const useUpdateProductsUrlQueryParams = (): void => {
  const universalProductFilters = useSelector(getUniversalProductsFilter);
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams();
    if (universalProductFilters?.textFilters instanceof Map && universalProductFilters?.textFilters.size > 0) {
      for (const [key, values] of universalProductFilters.textFilters) {
        values.forEach((value) => params.append(key, value));
      }
    }
    const search = params.toString();
    if (search) {
      history.replace({ search: `?${search}` });
    } else {
      history.replace({ search: '' });
    }
  }, [history, universalProductFilters]);
};

export const useFilterPresetFromQueryParams = (textFiltersFacets: TextFacetLocal[]): void => {
  const dispatch = useDispatch();
  const universalProductFilters = useSelector(getUniversalProductsFilter);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (!universalProductFilters.filterInitialized) {
      const textFacetKeys = textFiltersFacets?.map((facet) => facet.id);
      if (!textFacetKeys) {
        return;
      }

      const initialTextFacets = new Map<string, string[]>();

      textFacetKeys.forEach((id) => {
        const items = urlParams.getAll(id);
        if (items.length > 0) {
          initialTextFacets.set(id, items);
        }
      });

      if (initialTextFacets.size > 0) {
        dispatch(setUniversalProductsInitialTextFilters(initialTextFacets));
      }
    }
  }, [dispatch, textFiltersFacets, universalProductFilters.filterInitialized]);
};
